import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseResolver } from '@principle-theorem/ng-shared';
import { ConditionConfiguration } from '@principle-theorem/principle-core';
import {
  type IBrand,
  type IConditionConfiguration,
} from '@principle-theorem/principle-core/interfaces';
import { type CollectionReference } from '@principle-theorem/shared';
import { type WithRef } from '@principle-theorem/shared';

@Injectable()
export class BrandConditionConfigurationCollectionResolverService extends BaseResolver<
  CollectionReference<IConditionConfiguration>
> {
  resolve(
    route: ActivatedRouteSnapshot
  ): CollectionReference<IConditionConfiguration> {
    const brand = this._findInheritedRouteData<WithRef<IBrand>>(route, 'brand');
    if (!brand) {
      throw new Error('No Brand found');
    }
    return ConditionConfiguration.col(brand);
  }
}
